import { DefaultCustomerIcon } from './customer-default';
import { JiraIcon } from './jira-icon';

const SoftwareIcons = {
  JiraIcon,
  DefaultCustomerIcon,
};

export default SoftwareIcons;
